import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private authService: OAuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.authService.getAccessToken();

    if (token && this.isEsspApi(request.url)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    return next.handle(request);
  }

  isEsspApi(url: string): boolean {
    return [
      environment.appBackendUrl,
      environment.portalHomeUrl,
      environment.portalMetaBackendUrl,
    ].some((api) => url.startsWith(api));
  }
}
